import { render, staticRenderFns } from "./chat-window.vue?vue&type=template&id=142323c2&scoped=true&"
import script from "./chat-window.vue?vue&type=script&lang=js&"
export * from "./chat-window.vue?vue&type=script&lang=js&"
import style0 from "./chat-window.vue?vue&type=style&index=0&id=142323c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142323c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142323c2')) {
      api.createRecord('142323c2', component.options)
    } else {
      api.reload('142323c2', component.options)
    }
    module.hot.accept("./chat-window.vue?vue&type=template&id=142323c2&scoped=true&", function () {
      api.rerender('142323c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-window/chat-window.vue"
export default component.exports